import React from "react";
import { formatCLP } from "../../Helper/Cotizacion/currencyUtils";

const QuoteTotals = ({ quote }) => {
	const isExenta = quote?.issuerSnapshot?.tipoTributario === "exenta";
	const discounts =
		(quote.lineDiscountsTotal || 0) + (quote.globalDiscount?.amount || 0);

	const row = (label, value, strong = false) => (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				padding: "4px 0",
				fontWeight: strong ? 700 : 400,
				borderTop: strong ? "1px solid #cbd5e0" : "none",
				marginTop: strong ? "6px" : 0,
				paddingTop: strong ? "8px" : "4px",
			}}
		>
			<span>{label}</span>
			<span>{formatCLP(value)}</span>
		</div>
	);

	return (
		<section style={{ marginBottom: "24px" }}>
			<h5 style={{ marginBottom: "8px" }}>Totales</h5>
			<div
				style={{
					background: "#f7fafc",
					border: "1px solid #e2e8f0",
					borderRadius: "8px",
					padding: "14px 16px",
					maxWidth: "420px",
				}}
			>
				{isExenta ? (
					<>
						<div
							style={{
								background: "#f0fff4",
								color: "#276749",
								padding: "6px 10px",
								borderRadius: "6px",
								marginBottom: "10px",
								fontSize: "13px",
								fontWeight: 600,
							}}
						>
							Operación exenta de IVA
						</div>
						{row("Subtotal", quote.subtotal || 0)}
						{row("Descuentos", discounts)}
						{row("Total exento", quote.grandTotal || 0, true)}
					</>
				) : (
					<>
						{row("Subtotal (neto)", quote.subtotal || 0)}
						{row("Descuentos", discounts)}
						{row("Neto", quote.netTotal || 0)}
						{row(`IVA ${quote.taxRate || 19}%`, quote.taxTotal || 0)}
						{row("Total", quote.grandTotal || 0, true)}
					</>
				)}
			</div>
		</section>
	);
};

export default QuoteTotals;
